import { z } from 'zod';

export const paymentTypeSchema = z.object({
  id: z.string(),
  code: z.string().optional(),
  name: z.string().optional(),
  eType: z.number(),
  eTypeString: z.string().optional(),
  isFromManager: z.boolean(),
  isActive: z.boolean().optional(),
});
export const getPaymentTypesSchema = z.array(paymentTypeSchema);

export type GetPaymentsResponse = z.infer<typeof getPaymentTypesSchema>;
